// Somlogica van de herbestelpagina (spoedronde 16-08), losgetrokken
// uit de component zodat de rekenregels los van de UI toetsbaar zijn.
//
// De fout die hier is rechtgezet: de tellerbalk telde regels
// ("1 product") terwijl het totaal wél prijs × aantal optelde, en de
// productregel toonde de stukprijs zonder het aantal. Alles rekent nu
// op dezelfde definitie: stuks.

export interface BerekeningRegel {
  vid: string;
  prijs_cents: number | null;
}

export interface BerekeningCombideal {
  prijs_cents: number | null;
  prijs_met_korting_cents: number | null;
}

export interface Totalen {
  /** Aantal stuks over alle meedoende regels, plus de combideal. */
  stuks: number;
  totaalCents: number;
}

/** Doet deze regel mee? Aangevinkt én aantal minstens 1 (fix 16-08:
 * een hoofdproduct op 0 verdwijnt uit som, teller en winkelwagen). */
export function doetMee(
  regel: BerekeningRegel,
  aantallen: Record<string, number>,
  aangevinkt: Record<string, boolean>,
): boolean {
  return Boolean(aangevinkt[regel.vid]) && (aantallen[regel.vid] ?? 1) > 0;
}

/** Regeltotaal in centen: stukprijs × aantal. */
export function regelTotaalCents(
  prijsCents: number | null,
  aantal: number,
): number {
  return (prijsCents ?? 0) * aantal;
}

/**
 * De totalen van de balk: stuks en totaalbedrag op één definitie.
 *
 * De combideal telt als één stuk en rekent met de kortingsprijs zodra
 * die er is. Spaarpunten en de gratis-verzendingsgrens rekenen elders
 * verder op ``totaalCents`` en lopen dus per definitie in de pas.
 */
export function berekenTotalen(
  regels: BerekeningRegel[],
  aantallen: Record<string, number>,
  aangevinkt: Record<string, boolean>,
  combideal: BerekeningCombideal | null,
  combidealGekozen: boolean,
): Totalen {
  let stuks = 0;
  let totaalCents = 0;
  for (const regel of regels) {
    if (!doetMee(regel, aantallen, aangevinkt)) continue;
    const aantal = aantallen[regel.vid] ?? 1;
    stuks += aantal;
    totaalCents += regelTotaalCents(regel.prijs_cents, aantal);
  }
  if (combidealGekozen && combideal) {
    stuks += 1;
    totaalCents +=
      combideal.prijs_met_korting_cents ?? combideal.prijs_cents ?? 0;
  }
  return { stuks, totaalCents };
}
